module.exports = __webpack_public_path__ + "assets/img/ctzq.1764732f.png";